import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: ${theme.colors.neutral.variant[0]};
    border: 1px solid ${theme.colors.neutral.variant[10]};
    border-radius: 8px;
    padding: 6px 0;
    width: 100%;
  `,
  content: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 24px 12px;
    width: 100%;
    background-color: ${theme.colors.neutral.variant[0]};
  `,
  iconWrapper: css`
    display: inline-flex;
    align-items: center;
    gap: 8px;
  `,
  title: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[70]};
    text-align: center;
    white-space: nowrap;
  `,
  description: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[70]};
    text-align: center;
  `,
  link: ({ theme }) => css`
    color: ${theme.colors.secondary.sky[60]};
    text-decoration: underline;
    cursor: pointer;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
